export var CostUnit;
(function (CostUnit) {
    CostUnit["COST_UNIT_CREDITS"] = "CREDITS";
    CostUnit["COST_UNIT_USD"] = "USD";
    CostUnit["COST_UNIT_UNSPECIFIED"] = "UNSPECIFIED";
})(CostUnit || (CostUnit = {}));
